import React from 'react';
import { Drawer, Collapse } from 'antd';
import MenuIcon from '@material-ui/icons/Menu';
import CloseIcon from '@material-ui/icons/Close';
import { generalS } from "../../strings/general";

import { Link } from "react-router-dom";
import madboya from "../../imgs/favicon.png";


const { Panel } = Collapse;

class DrawerManager extends React.Component {
  state = { visible: false };

  showDrawer = () => {
    this.setState({
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  render() {
    let { language, context, authenticated } = this.props;
    return (
      <div>
        <MenuIcon
          className={"header-drawar"}
          onClick={this.showDrawer} />
        <Drawer
          placement="left"
          closable={false}
          onClose={this.onClose}
          visible={this.state.visible}
        >
          <div style={{ marginTop: 14, marginBottom: 48 }}>
            <CloseIcon
              className={"header-drawar"}
              onClick={this.onClose} />
          </div>
          <div>
            <Link to="/">
              <p className={"header-list-item"}>
                {generalS.home[language]}
              </p>
            </Link>
            <Collapse defaultActiveKey={['1']} style={{ border: 'none' }}>
              <Panel header={generalS.news[language]} key="1">
                <Link to="/projects">
                  <p className={"header-list-item"}>
                    {generalS.latestProject[language]}
                  </p>
                </Link>
              </Panel>
            </Collapse>

            <Link to="/product">
              <p className={"header-list-item"}>
                {generalS.product[language]}
              </p>
            </Link>

            <Link to="/about">
              <p className={"header-list-item"}>
                {generalS.about[language]}
              </p>
            </Link>
            {authenticated ?
              <Collapse defaultActiveKey={['1']} style={{ border: 'none' }}>
                <Panel header={generalS.cpanel[language]} key="1">
                  <Link to="/post">
                    <p className={"header-list-item"}>
                      {generalS.post[language]}
                    </p>
                  </Link>
                  <Link to="/user">
                    <p className={"header-list-item"}>
                      {generalS.userManagment[language]}
                    </p>
                  </Link>
                  <Link to="/settings">
                    <p className={"header-list-item"}>
                      {generalS.settings[language]}
                    </p>
                  </Link>
                  <p className={"header-list-item"} onClick={() => context.logout()}>
                    {generalS.logout[language]}
                  </p>
                </Panel>
              </Collapse>
              : ("")
            }
          </div>
          <div className={"drawer-logo"}>
            <Link to="/">
              {" "}
              <img
                src={madboya}
                style={{ width: 150 }}
              />
            </Link>
          </div>
        </Drawer>
      </div>
    );
  }
}

export default DrawerManager;